// Use an immediately invoked function expression (IIFE) to create a closure
(function () {
  window.colorsData = window.colorsData || {};

  async function preLoadSwatches() {
    try {
      let colors = document.querySelectorAll('.cusSwatchesBody .swatchesPanel-item__link, .cusSwatchesBody .color-swatch-link');
      
      if (colors.length === 0) {
        console.warn('No color swatches found');
        return;
      }

      // No await - fetches run in parallel but function doesn't wait
      Array.from(colors).forEach((color) => {
        if (!color.href || window.colorsData[color.href]) return;
        
        fetch(color.href)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            window.colorsData[color.href] = text;
          })
          .catch((error) => {
            console.error('Failed to load color:', color.href, error);
          });
      });
    } catch (error) {
      console.error('Error in preLoadSwatches:', error);
    }
  }

  // Private variable, not accessible from outside this scope
  let swatchRequestInProgress = false;

  function swatchesModalOpen(title) {
    const selectedPrintImg = document.querySelector(`.swatchesHoverUniqueImage[data-title="${title}"]`)?.getAttribute('data-src');
    if (!selectedPrintImg) {
      return;
    }
    let imgFirstSpl;
    let imgSecSpl;
    let finalImageUrl;
    const fileExtensions = ['.jpg', '.png', '.jpeg'];
    const selectedExtension = fileExtensions.find((ext) => selectedPrintImg.includes(ext));
    let aspectRatio = `_400x`;
    if (selectedExtension) {
      imgFirstSpl = selectedPrintImg.split(selectedExtension)[0];
      imgSecSpl = selectedPrintImg.split(selectedExtension)[1];

      finalImageUrl = `${imgFirstSpl}${selectedExtension}${imgSecSpl}`;
      if (finalImageUrl.includes('_400x')) {
        finalImageUrl = finalImageUrl;
      } else {
        finalImageUrl = `${imgFirstSpl}${aspectRatio}${selectedExtension}${imgSecSpl}`;
      }
    }
    document.querySelector(`.swatches-modal[data-title="${title}"] img`).src = finalImageUrl;
  }

  function updateOtherSections(doc) {
    try {
      const newArrivalsSection = document.querySelector('.section-new-arrivals');
      if (newArrivalsSection) {
        newArrivalsSection.innerHTML = doc.querySelector('.section-new-arrivals').innerHTML;
      }

      const loveThisPrintSection = document.querySelector('.section-love-this-print');
      if (loveThisPrintSection) {
        loveThisPrintSection.innerHTML = doc.querySelector('.section-love-this-print').innerHTML;
      }

      initProductListSlider();
      initColorSwatchSlider();
    } catch (error) {
      console.error('Error updating other sections:', error);
    }
  }

  async function reInitProductPersonalizer(url) {
    try {
      // Fetch JS data
      const jsResponse = await fetch(url + '.js');
      const productDataJs = await jsResponse.json();

      // Fetch JSON data
      const jsonResponse = await fetch(url + '.json');
      const productDataJson = await jsonResponse.json();
      document.title = `${productDataJson.product.title}`;

      window.pplr_prod_id = undefined;
      window.pplr_Loaded = undefined;
      window.product_personalizer_loaded = undefined;
      window.pplr_product = productDataJs;
      window.pplr_product_json = productDataJson?.product;

      const loadScript = (src, callback) => {
        // remove old scripts if present 
        const script = document.createElement("script");
        script.src = src;
        script.onload = callback;
        script.onerror = () => {
          console.log(`Failed to load script: ${src}`);
        };

        const mainProductContainer = document.querySelector('product-info');
        mainProductContainer.appendChild(script);
      };

      const currentProductId = productDataJs?.id;

      const oldScripts = document.querySelectorAll(`script[src*="https://cdn-zeptoapps.com"]`);
      if (oldScripts.length > 0) {
        oldScripts.forEach((oldScript) => {
          oldScript.remove();
        });
      }

      loadScript(
        "https://cdn-zeptoapps.com/product-personalizer/pplr_common.js",
        () => {
          loadScript(
            `https://cdn-zeptoapps.com/product-personalizer/canvas-script.php?shop=printfresh.myshopify.com&prid=${currentProductId}&kkr=tomato`,
            () => {
              // loadScript(
              //   "https://cdn-zeptoapps.com/product-personalizer/canvas-script-with-view.js",
              //   () => {
              loadScript(
                "https://cdn-zeptoapps.com/product-personalizer/changedpi.js",
                () => {
                  console.log("All scripts loaded successfully.");
                }
              );
              // }
              // );
            }
          );
        }
      );
    } catch (e) {
      console.log("Error while loading zepto script: ", e.message);
    }
  }

  async function colorSwatchPDPChange(event) {
    event.preventDefault();

    const mainProductContainer = document.querySelector('product-info');
    const link = event.currentTarget.closest('a');

    console.log('event', event.currentTarget.closest('a'));

    console.log('colorSwatchPDPChange', link);

    try {
      const url = link.href;

      const linkUrl = new URL(url);
      const linkPath = linkUrl.pathname;

      if (linkPath === window.location.pathname) return;

      // Prevent multiple simultaneous swatch changes
      if (swatchRequestInProgress) return;

      // Add loading indicator to the product container
      if (!mainProductContainer) {
        swatchRequestInProgress = false;
        return;
      }

      mainProductContainer.classList.add('loading');

      let colorHtml = window.colorsData[url];

      if (!colorHtml) {
        const colorResponse = await fetch(url);
        if (!colorResponse.ok) {
          throw new Error(`HTTP error! status: ${colorResponse.status}`);
        }

        colorHtml = await colorResponse.text();
      }
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(colorHtml, 'text/html');

      const newMainProduct = doc.querySelector('product-info');
      const productMedia = newMainProduct.querySelector('.product__media-wrapper');

      const quickAddModals = document.querySelectorAll('.quick-add-modal');
      quickAddModals.forEach((modal) => { modal.remove() });

      if (newMainProduct && mainProductContainer) {
        const producModal = document.getElementById(`ProductModal-${mainProductContainer.dataset.section}`);
        if (producModal) producModal.remove();

        // Get important data attributes before replacing content
        const oldUrl = mainProductContainer.dataset.url;
        const oldProductId = mainProductContainer.dataset.productId;
        const oldSection = mainProductContainer.dataset.section;

        // Change URL without reloading the page
        window.history.pushState({ path: url }, '', url);

        // Replace the content
        mainProductContainer.innerHTML = newMainProduct.innerHTML;

        // Restore important data attributes
        mainProductContainer.dataset.url = newMainProduct.dataset.url || oldUrl;
        mainProductContainer.dataset.productId = newMainProduct.dataset.productId || oldProductId;
        mainProductContainer.dataset.section = oldSection;

        // Re-initialize the nedia slider
        mainProductContainer.initializeMediaGallery();

        // Reinitialize Yotpo widgets
        if (window.yotpo) {
          window.yotpo.refreshWidgets();
        }

        // Reinitialize TryNow
        if (window.trynow && typeof window.trynow.reset === 'function') {
          window.trynow.reset();
        }

        updateOtherSections(doc);

        // Trigger Easy Size readiness event
        window.dispatchEvent(new Event('easySizeReady'));

        reInitProductPersonalizer(url);
      }
    } catch (error) {
      console.error('Error in colorSwatchPDPChange:', error);
    } finally {
      // Reset loading states
      if (mainProductContainer) {
        mainProductContainer.classList.remove('loading');
      }
      swatchRequestInProgress = false;
    }
  }

  // Expose these functions to the global scope
  window.swatchesModalOpen = swatchesModalOpen;
  window.colorSwatchPDPChange = colorSwatchPDPChange;

  preLoadSwatches();

  window.addEventListener('popstate', function (event) {
    location.reload(); // Reload the page when navigating back or forward
  });
})();
